function seededShuffle<T>(array: T[], seed: number): T[] {
  const result = [...array];
  let currentSeed = seed;

  const random = () => {
    currentSeed = (currentSeed * 1103515245 + 12345) & 0x7fffffff;
    return currentSeed / 0x7fffffff;
  };

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
}

const rawQuestions = [
  // HIRSLILIK (AMBITION)
  {
    id: 'amb1',
    characteristicId: 'ambition',
    text: 'Son üç ay içinde, proaktif olarak yeni fırsatlar aradım.',
    reversed: false
  },
  {
    id: 'amb2',
    characteristicId: 'ambition',
    text: 'Ulaşılması zor olabilecek hedefler koymaktan sık sık kaçınırım.',
    reversed: true
  },
  {
    id: 'amb3',
    characteristicId: 'ambition',
    text: 'Bir hedefe ulaştığımda hemen kendime daha yüksek bir hedef belirlerim.',
    reversed: false
  },
  {
    id: 'amb4',
    characteristicId: 'ambition',
    text: 'Aksiliklerle karşılaştığımda motivasyonumu korumakta zorlanırım.',
    reversed: true
  },
  {
    id: 'amb5',
    characteristicId: 'ambition',
    text: 'Kariyerimde veya kişisel hayatımda benden beklenenin ötesine geçmek için inisiyatif alırım.',
    reversed: false
  },
  {
    id: 'amb6',
    characteristicId: 'ambition',
    text: 'Daha büyük başarılara ulaşmak için çabalamak yerine konfor alanımda kalmayı tercih ederim.',
    reversed: true
  },
  {
    id: 'amb7',
    characteristicId: 'ambition',
    text: 'Uzun vadeli hedeflerime doğru kaydettiğim ilerlemeyi düzenli olarak takip ederim.',
    reversed: false
  },
  {
    id: 'amb8',
    characteristicId: 'ambition',
    text: 'Daha büyük hedeflerim için harekete geçmekte sık sık tereddüt ederim.',
    reversed: true
  },
  {
    id: 'amb9',
    characteristicId: 'ambition',
    text: 'Gelecekte nerede olmak istediğime dair net bir vizyonum var ve bunun için çalışırım.',
    reversed: false
  },
  {
    id: 'amb10',
    characteristicId: 'ambition',
    text: 'Anlamlı hedefler belirlemeyi ara sıra erteleyebilirim.',
    reversed: true
  },
  {
    id: 'amb11',
    characteristicId: 'ambition',
    text: 'Uzun vadeli hedeflerime ulaşmak için fedakarlık yapmaya hazırım.',
    reversed: false
  },
  {
    id: 'amb12',
    characteristicId: 'ambition',
    text: 'Motivasyon seviyemin dışsal koşullar tarafından belirlenmesine izin veririm.',
    reversed: true
  },

  // CESARETLILIK (BOLDNESS)
  {
    id: 'bold1',
    characteristicId: 'boldness',
    text: 'Son üç ay içinde önemli kazanımlar sağlayabilecek riskler aldım.',
    reversed: false
  },
  {
    id: 'bold2',
    characteristicId: 'boldness',
    text: 'Karar almadan önce genellikle başkalarının harekete geçmesini beklerim.',
    reversed: true
  },
  {
    id: 'bold3',
    characteristicId: 'boldness',
    text: 'Bir şeye güçlü şekilde inanıyorsam, zor durumlarda bile fikrimi açıkça ifade ederim.',
    reversed: false
  },
  {
    id: 'bold4',
    characteristicId: 'boldness',
    text: 'Kendimi rahatsız hissettirdiği için alışık olmadığım durumlardan kaçınırım.',
    reversed: true
  },
  {
    id: 'bold5',
    characteristicId: 'boldness',
    text: 'Son üç ay içinde, konfor alanımın dışına çıkmayı gerektiren seçimler yaptım.',
    reversed: false
  },
  {
    id: 'bold6',
    characteristicId: 'boldness',
    text: 'Cesur kararlar alırken kendi kararlarımı sık sık sorgularım.',
    reversed: true
  },
  {
    id: 'bold7',
    characteristicId: 'boldness',
    text: 'Yeni zorlukları tehdit olarak değil, büyüme fırsatı olarak kabul ederim.',
    reversed: false
  },
  {
    id: 'bold8',
    characteristicId: 'boldness',
    text: 'Kendimi, çok öne çıkabileceğim durumlardan kaçınırken bulurum.',
    reversed: true
  },
  {
    id: 'bold9',
    characteristicId: 'boldness',
    text: 'Gerektiğinde zor kararları alma sorumluluğunu üstlenirim.',
    reversed: false
  },
  {
    id: 'bold10',
    characteristicId: 'boldness',
    text: 'Katılmasam bile geleneksel düşünceyi sorgulamaktan çekinirim.',
    reversed: true
  },
  {
    id: 'bold11',
    characteristicId: 'boldness',
    text: 'Belirli bir risk söz konusu olsa bile yeni bir şeyi ilk deneyen kişi olmaya istekliyim.',
    reversed: false
  },
  {
    id: 'bold12',
    characteristicId: 'boldness',
    text: 'Karşı çıkanlar olsa bile kararımın arkasında durmam gerektiğinde kendimi rahatsız hissederim.',
    reversed: true
  },

  // DOGRULUK (INTEGRITY)
  {
    id: 'int1',
    characteristicId: 'integrity',
    text: 'Son üç ay içinde, zor olduğunda bile prensiplerimin arkasında durdum.',
    reversed: false
  },
  {
    id: 'int2',
    characteristicId: 'integrity',
    text: 'Baskı altındayken bazen etik standartlarımı esnetirim.',
    reversed: true
  },
  {
    id: 'int3',
    characteristicId: 'integrity',
    text: 'Hatalarımdan dolayı dış etkenleri suçlamak yerine sorumluluğu üstlenirim.',
    reversed: false
  },
  {
    id: 'int4',
    characteristicId: 'integrity',
    text: 'Benim için uygun olmadığında, verdiğim bir sözü bilerek tutmadığım olmuştur.',
    reversed: true
  },
  {
    id: 'int5',
    characteristicId: 'integrity',
    text: 'Son üç ayda kısa vadeli kazançlar yerine temel değerlerime göre kararlar aldım.',
    reversed: false
  },
  {
    id: 'int6',
    characteristicId: 'integrity',
    text: 'Bazen yanıldığımı kabul etmekten kaçınırım.',
    reversed: true
  },
  {
    id: 'int7',
    characteristicId: 'integrity',
    text: 'Yeteneklerim ve sınırlarım konusunda hem kendime hem de başkalarına karşı dürüst olmuşumdur.',
    reversed: false
  },
  {
    id: 'int8',
    characteristicId: 'integrity',
    text: 'Onay almak için başarılarımı abarttığım olmuştur.',
    reversed: true
  },
  {
    id: 'int9',
    characteristicId: 'integrity',
    text: 'Zor olsa bile verdiğim taahhütleri yerine getiririm.',
    reversed: false
  },
  {
    id: 'int10',
    characteristicId: 'integrity',
    text: 'Takım çalışmalarında başkalarının katkılarını küçümsediğim olmuştur.',
    reversed: true
  },
  {
    id: 'int11',
    characteristicId: 'integrity',
    text: 'Kendime doğrudan bir fayda sağlamasa bile insanlara adil ve tutarlı davranırım.',
    reversed: false
  },
  {
    id: 'int12',
    characteristicId: 'integrity',
    text: 'Çatışmadan kaçınmak için değerlerimden ödün verdiğim olmuştur.',
    reversed: true
  },

  // OLUMLU BAKIS ACISI (POSITIVE OUTLOOK)
  {
    id: 'pos1',
    characteristicId: 'positiveOutlook',
    text: 'Son üç ay içinde karşılaştığım zorluklarda olumlu yönleri görmeye çalıştım.',
    reversed: false
  },
  {
    id: 'pos2',
    characteristicId: 'positiveOutlook',
    text: 'Çoğu zaman işlerin yolunda gideceğinden çok, ters gideceğini düşünürüm.',
    reversed: true
  },
  {
    id: 'pos3',
    characteristicId: 'positiveOutlook',
    text: 'Sorunlara takılmak yerine çözüm bulmaya odaklanırım.',
    reversed: false
  },
  {
    id: 'pos4',
    characteristicId: 'positiveOutlook',
    text: 'Çoğu zaman en kötü sonucun gerçekleşeceğini düşünürüm.',
    reversed: true
  },
  {
    id: 'pos5',
    characteristicId: 'positiveOutlook',
    text: 'Zor durumlarda zaman ve çabayla her şeyin düzelebileceğini kendime hatırlatırım.',
    reversed: false
  },
  {
    id: 'pos6',
    characteristicId: 'positiveOutlook',
    text: 'Aksilikleri geçici yerine kalıcı olarak görme eğilimindeyim.',
    reversed: true
  },
  {
    id: 'pos7',
    characteristicId: 'positiveOutlook',
    text: 'Yeni projelere veya deneyimlere başlarken heyecanımı korurum.',
    reversed: false
  },
  {
    id: 'pos8',
    characteristicId: 'positiveOutlook',
    text: 'Zor durumların olumlu yönlerini görmekte çoğu zaman zorlanırım.',
    reversed: true
  },
  {
    id: 'pos9',
    characteristicId: 'positiveOutlook',
    text: 'Zorlukların üstesinden gelme ve koşullarımı daha iyi hale getirme becerime güvenirim.',
    reversed: false
  },
  {
    id: 'pos10',
    characteristicId: 'positiveOutlook',
    text: 'İşler planlandığı gibi gitmediğinde kolayca moralim bozulur.',
    reversed: true
  },
  {
    id: 'pos11',
    characteristicId: 'positiveOutlook',
    text: 'Zor anlarda bile işlerin genel olarak yoluna gireceğine güvenirim.',
    reversed: false
  },
  {
    id: 'pos12',
    characteristicId: 'positiveOutlook',
    text: 'Çoğunlukla çabalarımın uzun vadede bir fark yaratmayacağını hissederim.',
    reversed: true
  },

  // DINAMIK ENERJI (PASSION)
  {
    id: 'pas1',
    characteristicId: 'passion',
    text: 'İlgilendiğim konular üzerinde çalışırken enerji dolu hissederim.',
    reversed: false
  },
  {
    id: 'pas2',
    characteristicId: 'passion',
    text: 'Günlük sorumluluklarım beni sık sık tükenmiş hissettirir.',
    reversed: true
  },
  {
    id: 'pas3',
    characteristicId: 'passion',
    text: 'Hedeflerimin peşinden giderken yüksek enerji düzeyimi korurum.',
    reversed: false
  },
  {
    id: 'pas4',
    characteristicId: 'passion',
    text: 'Yeni projelere olan ilgimi genellikle kısa sürede kaybederim.',
    reversed: true
  },
  {
    id: 'pas5',
    characteristicId: 'passion',
    text: 'Öğrenmek ve kendimi geliştirmek bana heyecan verir.',
    reversed: false
  },
  {
    id: 'pas6',
    characteristicId: 'passion',
    text: 'Motivasyonumu uzun süre boyunca sürdürmekte zorlanırım.',
    reversed: true
  },
  {
    id: 'pas7',
    characteristicId: 'passion',
    text: 'Coşkum ve kararlılığımla başkalarına ilham veririm.',
    reversed: false
  },
  {
    id: 'pas8',
    characteristicId: 'passion',
    text: 'İşime duyduğum tutku ve heyecanı sürdürmekte zorlanırım.',
    reversed: true
  },
  {
    id: 'pas9',
    characteristicId: 'passion',
    text: 'Beni heyecanlandıran ve motive eden aktiviteleri aktif olarak ararım.',
    reversed: false
  },
  {
    id: 'pas10',
    characteristicId: 'passion',
    text: 'Zorlayıcı işleri yorucu bulduğum için onlardan kaçınırım.',
    reversed: true
  },
  {
    id: 'pas11',
    characteristicId: 'passion',
    text: 'Yaptığım işe yüreğimi koyarım.',
    reversed: false
  },
  {
    id: 'pas12',
    characteristicId: 'passion',
    text: 'Yaptığım işleri çoğu zaman içten bir heyecan duymadan yerine getiririm.',
    reversed: true
  },

  // SOSYALLIK (SOCIABILITY)
  {
    id: 'soc1',
    characteristicId: 'sociability',
    text: 'Yeni tanıştığım insanlarla kolayca samimi ilişkiler kurarım.',
    reversed: false
  },
  {
    id: 'soc2',
    characteristicId: 'sociability',
    text: 'Sosyal ortamlarda çoğu zaman kendimi rahatsız hissederim.',
    reversed: true
  },
  {
    id: 'soc3',
    characteristicId: 'sociability',
    text: 'Grup tartışmalarına etkili bir şekilde katkı sağlarım.',
    reversed: false
  },
  {
    id: 'soc4',
    characteristicId: 'sociability',
    text: 'Yabancılarla konuşma başlatmakta zorlanırım.',
    reversed: true
  },
  {
    id: 'soc5',
    characteristicId: 'sociability',
    text: 'Takım ortamlarında etkili bir şekilde yer alır ve katkı sağlarım.',
    reversed: false
  },
  {
    id: 'soc6',
    characteristicId: 'sociability',
    text: 'Uzun süreli ilişkileri sürdürmekte zorlanırım.',
    reversed: true
  },
  {
    id: 'soc7',
    characteristicId: 'sociability',
    text: 'İnsanlarla düzenli olarak yeni bağlantılar kurar ve ilişkiler geliştiririm.',
    reversed: false
  },
  {
    id: 'soc8',
    characteristicId: 'sociability',
    text: 'Profesyonel ortamlarda kendimi geri çekmeyi tercih ederim.',
    reversed: true
  },
  {
    id: 'soc9',
    characteristicId: 'sociability',
    text: 'Dahil edici ve kapsayıcı ortamlar yaratmak için aktif olarak çaba gösteririm.',
    reversed: false
  },
  {
    id: 'soc10',
    characteristicId: 'sociability',
    text: 'Gerek olmadıkça sosyal etkileşimlerden kaçınma eğilimindeyim.',
    reversed: true
  },
  {
    id: 'soc11',
    characteristicId: 'sociability',
    text: 'Farklı sosyal ortamlara kolayca uyum sağlarım.',
    reversed: false
  },
  {
    id: 'soc12',
    characteristicId: 'sociability',
    text: 'Farklı geçmişlere ve yaşam deneyimlerine sahip insanlarla bağ kurmakta zorlanırım.',
    reversed: true
  },

  // ILETISIM (COMMUNICATION)
  {
    id: 'com1',
    characteristicId: 'communication',
    text: 'Düşüncelerimi açık ve öz şekilde ifade ederim.',
    reversed: false
  },
  {
    id: 'com2',
    characteristicId: 'communication',
    text: 'Fikirlerimi etkili şekilde ifade etmekte sık sık zorlanırım.',
    reversed: true
  },
  {
    id: 'com3',
    characteristicId: 'communication',
    text: 'Aktif dinler ve başkalarını anlamaya çalışırım.',
    reversed: false
  },
  {
    id: 'com4',
    characteristicId: 'communication',
    text: 'Konuşurlarken başkalarının sözünü sık sık keserim.',
    reversed: true
  },
  {
    id: 'com5',
    characteristicId: 'communication',
    text: 'Farklı dinleyicilere göre iletişim tarzımı ayarlarım.',
    reversed: false
  },
  {
    id: 'com6',
    characteristicId: 'communication',
    text: 'Zor konuşmalardan mümkün olduğunca kaçınırım.',
    reversed: true
  },
  {
    id: 'com7',
    characteristicId: 'communication',
    text: 'Yapıcı geri bildirimi etkili şekilde veririm.',
    reversed: false
  },
  {
    id: 'com8',
    characteristicId: 'communication',
    text: 'Kötü dinleme nedeniyle başkalarını yanlış anlama eğilimim var.',
    reversed: true
  },
  {
    id: 'com9',
    characteristicId: 'communication',
    text: 'Mesajımın doğru anlaşıldığından emin olurum.',
    reversed: false
  },
  {
    id: 'com10',
    characteristicId: 'communication',
    text: 'Baskı altında düşüncelerimi ifade etmekte zorlanırım.',
    reversed: true
  },
  {
    id: 'com11',
    characteristicId: 'communication',
    text: 'Empati ve saygıyla iletişim kurarım.',
    reversed: false
  },
  {
    id: 'com12',
    characteristicId: 'communication',
    text: 'İletişim tarzımı uyarlamakta zorlanırım.',
    reversed: true
  },

  // MUHAKEME (WISDOM/JUDGMENT)
  {
    id: 'wis1',
    characteristicId: 'wisdom',
    text: 'Karar almadan önce birden çok bakış açısını dikkatle değerlendiririm.',
    reversed: false
  },
  {
    id: 'wis2',
    characteristicId: 'wisdom',
    text: 'Sonuçlarını tam olarak düşünmeden ani kararlar verme eğilimindeyim.',
    reversed: true
  },
  {
    id: 'wis3',
    characteristicId: 'wisdom',
    text: 'Karar verirken duygularım ile mantığım arasında denge kurarım.',
    reversed: false
  },
  {
    id: 'wis4',
    characteristicId: 'wisdom',
    text: 'Kısa vadeli konforu korumak için uzun vadeli sonuçları çoğu zaman göz ardı ederim.',
    reversed: true
  },
  {
    id: 'wis5',
    characteristicId: 'wisdom',
    text: 'Geçmiş deneyimlerden öğrenir ve bu dersleri yeni durumlara uygularım.',
    reversed: false
  },
  {
    id: 'wis6',
    characteristicId: 'wisdom',
    text: 'Karmaşık durumlarda tekrar eden kalıpları fark etmekte zorlanırım.',
    reversed: true
  },
  {
    id: 'wis7',
    characteristicId: 'wisdom',
    text: 'Önemli kararlar almadan önce daha deneyimli kişilerden aktif olarak tavsiye isterim.',
    reversed: false
  },
  {
    id: 'wis8',
    characteristicId: 'wisdom',
    text: 'Yeterli bilgi toplamadan hareket etme eğilimindeyim.',
    reversed: true
  },
  {
    id: 'wis9',
    characteristicId: 'wisdom',
    text: 'Önemli seçimler yaparken etik sonuçları dikkate alırım.',
    reversed: false
  },
  {
    id: 'wis10',
    characteristicId: 'wisdom',
    text: 'Acil ve önemli konuları ayırt etmekte güçlük çekerim.',
    reversed: true
  },
  {
    id: 'wis11',
    characteristicId: 'wisdom',
    text: 'Mevcut durumun ötesini görerek gelecekte ortaya çıkabilecek eğilimleri öngörebilirim.',
    reversed: false
  },
  {
    id: 'wis12',
    characteristicId: 'wisdom',
    text: 'Kararlarımı çoğu zaman dikkatli değerlendirmeler yerine anlık dürtülerle veririm.',
    reversed: true
  },

  // OGRENME (LEARNING)
  {
    id: 'lrn1',
    characteristicId: 'learning',
    text: 'Düzenli olarak yeni bilgi ve beceriler öğrenmenin yollarını aktif biçimde ararım.',
    reversed: false
  },
  {
    id: 'lrn2',
    characteristicId: 'learning',
    text: 'Yeni şeyler öğrenmeye, eğer büyük çaba gerektiriyorsa, direnirim.',
    reversed: true
  },
  {
    id: 'lrn3',
    characteristicId: 'learning',
    text: 'Geri bildirimi gelişmek için bir fırsat olarak görürüm.',
    reversed: false
  },
  {
    id: 'lrn4',
    characteristicId: 'learning',
    text: 'Geçmişteki hatalardan ders çıkarmanın değerini görmekte zorlanırım.',
    reversed: true
  },
  {
    id: 'lrn5',
    characteristicId: 'learning',
    text: 'Kişisel gelişimime ve kendimi geliştirmeye düzenli olarak zaman ayırırım.',
    reversed: false
  },
  {
    id: 'lrn6',
    characteristicId: 'learning',
    text: 'Yeni beceriler geliştirmemi gerektiren zorluklardan kaçınma eğilimindeyim.',
    reversed: true
  },
  {
    id: 'lrn7',
    characteristicId: 'learning',
    text: 'Yeni öğrendiğim bilgileri gerçek hayattaki durumlara uygulayabilirim.',
    reversed: false
  },
  {
    id: 'lrn8',
    characteristicId: 'learning',
    text: 'Mevcut inançlarıma ters düşen tavsiyeleri sık sık görmezden gelirim.',
    reversed: true
  },
  {
    id: 'lrn9',
    characteristicId: 'learning',
    text: 'İlgi alanımdaki gelişmeleri yakından takip ederim.',
    reversed: false
  },
  {
    id: 'lrn10',
    characteristicId: 'learning',
    text: 'Beni konfor alanımın dışına çıkarmaya zorlayan öğrenme fırsatlarından kaçınırım.',
    reversed: true
  },
  {
    id: 'lrn11',
    characteristicId: 'learning',
    text: 'Büyümemi hızlandırmak için mentorluk ve rehberlik ararım.',
    reversed: false
  },
  {
    id: 'lrn12',
    characteristicId: 'learning',
    text: 'Geçmiş deneyimlerim üzerinde düşünerek dersler çıkarmaya nadiren zaman ayırırım.',
    reversed: true
  },

  // YARATICILIK (CREATIVITY)
  {
    id: 'cre1',
    characteristicId: 'creativity',
    text: 'Problemlere yenilikçi çözümler üretirim.',
    reversed: false
  },
  {
    id: 'cre2',
    characteristicId: 'creativity',
    text: 'Alışılmış sınırların dışında düşünmekte zorlanırım.',
    reversed: true
  },
  {
    id: 'cre3',
    characteristicId: 'creativity',
    text: 'Tanıdık işleri yaparken yeni yaklaşımlar denemekten hoşlanırım.',
    reversed: false
  },
  {
    id: 'cre4',
    characteristicId: 'creativity',
    text: 'Riskli göründükleri için alışılmışın dışındaki fikirlerden kaçınırım.',
    reversed: true
  },
  {
    id: 'cre5',
    characteristicId: 'creativity',
    text: 'Yeni bakış açıları keşfetmek için geleneksel varsayımlara meydan okurum.',
    reversed: false
  },
  {
    id: 'cre6',
    characteristicId: 'creativity',
    text: 'Grup ortamlarında özgün fikirlerimi paylaşmakta tereddüt ederim.',
    reversed: true
  },
  {
    id: 'cre7',
    characteristicId: 'creativity',
    text: 'Grup tartışmalarına ve iş birliklerine farklı ve yaratıcı bakış açıları getiririm.',
    reversed: false
  },
  {
    id: 'cre8',
    characteristicId: 'creativity',
    text: 'Karşılaştığım zorluklara özgün çözümler üretmekte zorlanırım.',
    reversed: true
  },
  {
    id: 'cre9',
    characteristicId: 'creativity',
    text: 'Mevcut fikirleri yenilikçi biçimde uyarlarım.',
    reversed: false
  },
  {
    id: 'cre10',
    characteristicId: 'creativity',
    text: 'Yeni olasılıkları keşfetmek yerine rutin görevleri tercih ederim.',
    reversed: true
  },
  {
    id: 'cre11',
    characteristicId: 'creativity',
    text: 'Yeni kavramları hayal etmeyi ve beyin fırtınası yapmayı severim.',
    reversed: false
  },
  {
    id: 'cre12',
    characteristicId: 'creativity',
    text: 'İşleri yapmanın alternatif yollarını düşünmekte zorlanırım.',
    reversed: true
  },

  // UYUM YETENEGI (ADAPTABILITY/FLEXIBILITY)
  {
    id: 'flex1',
    characteristicId: 'flexibility',
    text: 'Beklenmedik değişikliklere iyi uyum sağlarım.',
    reversed: false
  },
  {
    id: 'flex2',
    characteristicId: 'flexibility',
    text: 'Planlarım aniden değiştiğinde rahatsız hissederim.',
    reversed: true
  },
  {
    id: 'flex3',
    characteristicId: 'flexibility',
    text: 'Belirsiz durumlarda bile üretken kalırım.',
    reversed: false
  },
  {
    id: 'flex4',
    characteristicId: 'flexibility',
    text: 'Gerekli olsa bile rutinimi değiştirmeye direnirim.',
    reversed: true
  },
  {
    id: 'flex5',
    characteristicId: 'flexibility',
    text: 'Koşullar değiştiğinde stratejilerimi değiştiririm.',
    reversed: false
  },
  {
    id: 'flex6',
    characteristicId: 'flexibility',
    text: 'İşler planlandığı gibi gitmediğinde sinirlenirim.',
    reversed: true
  },
  {
    id: 'flex7',
    characteristicId: 'flexibility',
    text: 'Yeni çalışma biçimlerini tereddüt etmeden kabul ederim.',
    reversed: false
  },
  {
    id: 'flex8',
    characteristicId: 'flexibility',
    text: 'Yeni zorluklarla karşılaştığımda bakış açımı değiştirmekte zorlanırım.',
    reversed: true
  },
  {
    id: 'flex9',
    characteristicId: 'flexibility',
    text: 'Baskı altında soğukkanlı kalır ve duruma göre uyum sağlarım.',
    reversed: false
  },
  {
    id: 'flex10',
    characteristicId: 'flexibility',
    text: 'Başarısızlıktan korktuğum için yeni yaklaşımlar denemekten kaçınırım.',
    reversed: true
  },
  {
    id: 'flex11',
    characteristicId: 'flexibility',
    text: 'Yeni beceriler ve bakış açıları geliştirmek için fırsatlar ararım.',
    reversed: false
  },
  {
    id: 'flex12',
    characteristicId: 'flexibility',
    text: 'Yaklaşımımı değiştirmemi öneren geri bildirimlere direnç gösteririm.',
    reversed: true
  },

  // VIZYONER DUSUNCE (VISIONARY THINKING)
  {
    id: 'vis1',
    characteristicId: 'visionaryThinking',
    text: 'Uzun vadeli olasılıkları ve hedefleri net bir şekilde hayal edebilirim.',
    reversed: false
  },
  {
    id: 'vis2',
    characteristicId: 'visionaryThinking',
    text: 'Acil ihtiyaçlarımın ötesindeki geleceği nadiren düşünürüm.',
    reversed: true
  },
  {
    id: 'vis3',
    characteristicId: 'visionaryThinking',
    text: 'Mevcut eylemlerimin uzun vadeli başarıma nasıl katkı sağladığını görebilirim.',
    reversed: false
  },
  {
    id: 'vis4',
    characteristicId: 'visionaryThinking',
    text: 'Karar verirken büyük resmi görmekte zorlanırım.',
    reversed: true
  },
  {
    id: 'vis5',
    characteristicId: 'visionaryThinking',
    text: 'Gelecekte ortaya çıkabilecek eğilimleri ve gelişmeleri gerçekleşmeden öngörebilirim.',
    reversed: false
  },
  {
    id: 'vis6',
    characteristicId: 'visionaryThinking',
    text: 'Uzun vadeli başarı için plan yapmakta zorlanırım.',
    reversed: true
  },
  {
    id: 'vis7',
    characteristicId: 'visionaryThinking',
    text: 'İleri görüşlü düşünce tarzımla başkalarına ilham veririm.',
    reversed: false
  },
  {
    id: 'vis8',
    characteristicId: 'visionaryThinking',
    text: 'Gerçekçi görünmedikleri için iddialı gelecek hedefleri belirlemekten kaçınırım.',
    reversed: true
  },
  {
    id: 'vis9',
    characteristicId: 'visionaryThinking',
    text: 'Gelecekteki hedeflerim için ayrıntılı planlar geliştiririm.',
    reversed: false
  },
  {
    id: 'vis10',
    characteristicId: 'visionaryThinking',
    text: 'Hayatıma dair net bir vizyon ortaya koymakta zorlanırım.',
    reversed: true
  },
  {
    id: 'vis11',
    characteristicId: 'visionaryThinking',
    text: 'Yeni fırsatlar yaratmak için geleneksel düşünceyi sorgularım.',
    reversed: false
  },
  {
    id: 'vis12',
    characteristicId: 'visionaryThinking',
    text: 'Fazla soyut göründükleri için yeni fikirleri keşfetmekte tereddüt ederim.',
    reversed: true
  }
];

export const questionsTR = seededShuffle(rawQuestions, 42);
